module.exports = __webpack_public_path__ + "img/androidMockShine.4dee01.png";